import React from 'react'

export default function ExecutiveCouncil() {
    return (
        <div>ExecutiveCouncil</div>
    )
}
